import { render } from "./BalanceInquiryMenuView.vue?vue&type=template&id=6b8db524"
import script from "./BalanceInquiryMenuView.vue?vue&type=script&lang=js"
export * from "./BalanceInquiryMenuView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__